<template>
  <AccountEvaluator></AccountEvaluator>
</template>

<script>
// @ is an alias to /src
import AccountEvaluator from '@/components/AccountEvaluator.vue'

export default {
  name: 'AccountEvaluatorView',
  components: {
    AccountEvaluator
  }
}
</script>
